import React from 'react'
import moment from "moment";
import Pagination from "../../../../../components/Pagination";
import TableHeader from "../../../../../components/TableHeader";
import GradeManager from "../../../../../components/Grade";
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../../services/system/student/student-controller";
import {toast} from "react-toastify";

class CustomTransferManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gradeId: 0,
            isShowText: true,
            oldClassRooms: [],
            newClassRooms: [],
            listTransferOld: [],
            listCheckedOld: [],

            listTransferNew: [],
            listCheckedNew: [],

            page: 0,
            pageNumberNew: 0,
            pageNumberOld: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: '',
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showModalCreate: false,
            showModalEdit: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center", minWidth: "30"},
                    sort: false,
                },
                {
                    id: 'name',
                    name: 'Họ và tên',
                    style: {textAlign: "center", minWidth: "30"},
                    sort: false,
                },
                {
                    id: 'birthday',
                    name: "Ngày sinh",
                    style: {textAlign: "center", minWidth: "30"},
                    sort: false,
                },
                {
                    id: 'sex',
                    name: "Giới tính",
                    style: {textAlign: "center", minWidth: "30"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center", minWidth: "30"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId
        };
        ClassRoomController.listLenLop(payload, res => {
            this.setState({
                showLoading: false,
                oldClassRooms: res.data.oldClassRooms,
                newClassRooms: res.data.newClassRooms,
            });
        })
    }
    renderOldClass() {
        return this.state.oldClassRooms.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }

    renderNewClass() {
        return this.state.newClassRooms.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListOldStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            classId: parseInt(this.state.oldClassId)
        };
        ClassRoomController.listHocSinh(payload, res => {
            this.setState({
                listOldStudent: res.data.oldStudents
            });
        })
    }
    getListNewStudent() {
        let payload = {
            yearId: -1,
            classRoomId: parseInt(this.state.newClassId),
            code: "",
            ethnic: "",
            fullName: "",
            studentState: "",
            gender: "",
            grade: "",
            pageNumber: this.state.pageNumberNew,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
        };
        StudentController.search(payload, res => {
            this.setState({
                showLoading: false,
                listNewStudent: res.data.content,
                newTotalItem: res.data.totalElements,
                newTotalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    getListHocSinh(){
        this.getListOldStudent()
        this.getListNewStudent()
    }
    ketChuyenLenLop() {
        let toClassId = parseInt(this.state.newClassId)
        if (this.state.listTransferOld.length < 1){
            toast.warning("Vui lòng chọn học sinh cần chuyển!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (isNaN(toClassId)){
            toast.warning("Vui lòng chọn lớp chuyển đến!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let results = []
            this.state.listTransferOld.forEach((id, index) => {
                results.push({
                    "studentId": id,
                    "toClassId": toClassId,
                })
            })
            if (results.length > 0){
                let payload = {
                    yearId: parseInt(getSchoolYear()),
                    items: results
                };
                ClassRoomController.ketChuyenHocSinh(payload, res => {
                    if (res.success) {
                        toast.success("Kết chuyển thành công!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                        this.state.listTransferOld = []
                        this.getListHocSinh()
                    } else {
                        toast.warning(res.message[0], {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                    }
                    this.setState({
                        showLoading: false
                    })
                })
            }else {
                toast.warning("Vui lòng chọn lớp kết chuyển", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        }
    }
    ketChuyenXuongLop() {
        let toClassId = parseInt(this.state.oldClassId)
        if (this.state.listTransferNew.length < 1){
            toast.warning("Vui lòng chọn học sinh cần chuyển!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (isNaN(toClassId)){
            toast.warning("Vui lòng chọn Lớp cần chuyển!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let results = []
            this.state.listTransferNew.forEach((id, index) => {
                results.push({
                    "studentId": id,
                    "toClassId": toClassId,
                })
            })
            if (results.length > 0){
                let payload = {
                    yearId: parseInt(getSchoolYear()),
                    items: results
                };
                ClassRoomController.ketChuyenHocSinhBack(payload, res => {
                    if (res.success) {
                        toast.success("Kết chuyển thành công!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                        this.state.listTransferNew = []
                        this.getListHocSinh()
                    } else {
                        toast.warning(res.message[0], {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                    }
                })
            }else {
                toast.warning("Vui lòng chọn lớp kết chuyển", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        }
    }
    handleChangePageOld = (page) => {
        this.setState(
            {
                pageNumberOld: page
            },
            () => {
                this.getListOldStudent()
            }
        );
    };
    handleChangePageNew = (page) => {
        this.setState(
            {
                pageNumberNew: page
            },
            () => {
                this.getListNewStudent()
            }
        );
    };

    render() {
        let {
            pageNumberNew,
            pageNumberOld,
            pageSize,
            isShowText,
            totalItem,
            gradeId
        } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="mb-4 col-md-12 tab-content">
                        {this.state.showLoading &&
                        <div className="content-loading col-12 ml-3 align-items-center"
                             style={{display: 'block'}}>
                            <div className="spinner-grow text-info"/>
                        </div>
                        }
                        <div className="col-12">
                            <div className='mb-4'>
                                <div className="kt-form kt-form--fit">
                                    <div className="row">
                                        <div className='col-md-5 p-0 pr-3 d-flex mb-4'>
                                            <label className="col-4 label-item pl-0">Khối học[Năm cũ]</label>
                                            <GradeManager
                                                isShowText={isShowText}
                                                gradeId={gradeId}
                                                onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-md-5 p-0 pr-3 d-flex mb-4'>
                                            <label className="col-4 label-item pl-0">Lớp cần chuyển</label>
                                            <select
                                                className="form-control kt-input pd-4-input hei-input"
                                                value={this.state.oldClassId}
                                                onChange={(e) => {
                                                    this.state.oldClassId = e.target.value;
                                                    this.setState({
                                                        oldClassId: e.target.value
                                                    }, () =>{
                                                        this.getListOldStudent()
                                                    })
                                                }}
                                            >
                                                <option value="">Chọn lớp</option>
                                                {this.renderOldClass()}
                                            </select>
                                        </div>
                                        <div className='col-md-1' style={{textAlign: "center"}}>
                                        </div>
                                        <div className='col-md-5 p-0 pr-3 d-flex mb-4'>
                                            <label className="col-4 label-item pl-0">Lớp chuyển đến</label>
                                            <select
                                                className="form-control kt-input pd-4-input hei-input"
                                                value={this.state.newClassId}
                                                onChange={(e) => {
                                                    this.state.newClassId = e.target.value;
                                                    this.setState({
                                                        newClassId: e.target.value
                                                    }, () =>{
                                                        this.getListNewStudent()
                                                    })
                                                }}
                                            >
                                                <option value="">Chọn lớp</option>
                                                {this.renderNewClass()}
                                            </select>
                                        </div>
                                        <div className='col-md-5 mb-2'>
                                            <div className="table-wrapper">
                                                <table className="table table-striped table-data table-bordered">
                                                    <thead>
                                                    <TableHeader header={this.state.header} clickSort={(data) => {
                                                        let a = ""
                                                    }}/>
                                                    </thead>
                                                        {!this.state.listOldStudent || this.state.listOldStudent.length == 0
                                                        ? <tbody>
                                                        <tr>
                                                            <td colSpan={12}>
                                                                <div className='text-center'>Không có dữ liệu</div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                        : <tbody>
                                                        {this.state.listOldStudent.map((row, index) => (
                                                            <tr key={row.id} style={{height: 50}}>
                                                                <td style={{textAlign: 'center'}}>{pageNumberOld * pageSize + index + 1}</td>
                                                                <td style={{textAlign: 'left',}}>
                                                                    {row.fullName}
                                                                </td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                                </td>
                                                                <td style={{textAlign: 'left'}}>
                                                                    {row.gender=="MALE" ? 'Nam' : 'Nữ'}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.listCheckedOld.length > 0?this.state.listCheckedOld[parseInt(row.id)] : false}
                                                                        onChange={(e) => {
                                                                            let id = parseInt(row.id)
                                                                            let isChecked = e.target.checked;
                                                                            let pos = this.state.listTransferOld.indexOf(id)
                                                                            if (isChecked){
                                                                                if (pos < 0)
                                                                                    this.state.listTransferOld.push(id)
                                                                            }else {
                                                                                if (pos > -1){
                                                                                    this.state.listTransferOld.splice(index, 1);
                                                                                }
                                                                            }
                                                                            this.state.listCheckedOld[id] = isChecked
                                                                            this.setState(this.state.listCheckedOld)
                                                                        }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>}
                                                </table>
                                            </div>
                                            <div className="pagination-right">
                                                <Pagination
                                                    activePage={this.state.pageNumberOld}
                                                    itemsCountPerPage={this.state.pageSize}
                                                    totalItemsCount={totalItem}
                                                    changeHandler={page => this.handleChangePageOld(page)}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-md-1' style={{textAlign: "center"}}>
                                            <button
                                                type="button"
                                                className="col-12 border-1-s background-btn type-button-fix btn btn-primary btn-sm shadow-none mt-2"
                                                style={{height: 35}}
                                                onClick={() => {
                                                    this.ketChuyenLenLop();
                                                }}
                                            >
                                                <i className="fas fa-angle-double-right"/>
                                            </button>
                                            <button
                                                type="button" className="col-12 btn border-1-s btn-light btn-sm mt-2"
                                                style={{height: 35}}
                                                onClick={() => {
                                                    this.ketChuyenXuongLop();
                                                }}
                                            >
                                                <i className="fas fa-angle-double-left"/>
                                            </button>
                                        </div>
                                        <div className='col-md-5 mb-2'>
                                            <div className="table-wrapper">
                                                <table className="table table-striped table-data table-bordered">
                                                <thead>
                                                <TableHeader header={this.state.header} clickSort={(data) => {
                                                    let a = ""
                                                }}/>
                                                </thead>
                                                {!this.state.listNewStudent || this.state.listNewStudent.length == 0
                                                    ? <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className='text-center'>Không có dữ liệu</div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                    : <tbody>
                                                    {this.state.listNewStudent.map((row, index) => (
                                                        <tr key={row.id} style={{height: 50}}>
                                                            <td style={{textAlign: 'center'}}>{pageNumberOld * pageSize + index + 1}</td>
                                                            <td style={{textAlign: 'left',}}>
                                                                {row.fullName}
                                                            </td>
                                                            <td style={{textAlign: 'center'}}>
                                                                {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                            </td>
                                                            <td style={{textAlign: 'left'}}>
                                                                {row.gender=="MALE" ? 'Nam' : 'Nữ'}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.listCheckedNew.length > 0?this.state.listCheckedNew[parseInt(row.id)] : false}
                                                                    onChange={(e) => {
                                                                        let id = parseInt(row.id)
                                                                        let isChecked = e.target.checked;
                                                                        let pos = this.state.listTransferNew.indexOf(id)
                                                                        if (isChecked){
                                                                            if (pos < 0)
                                                                                this.state.listTransferNew.push(id)
                                                                        }else {
                                                                            if (pos > -1){
                                                                                this.state.listTransferNew.splice(index, 1);
                                                                            }
                                                                        }
                                                                        this.state.listCheckedNew[id] = isChecked
                                                                        this.setState(this.state.listCheckedNew)
                                                                    }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>}
                                            </table>
                                            </div>
                                            <div className="pagination-right">
                                                <Pagination
                                                    activePage={this.state.pageNumberNew}
                                                    itemsCountPerPage={this.state.pageSize}
                                                    totalItemsCount={totalItem}
                                                    changeHandler={page => this.handleChangePageNew(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default CustomTransferManagement
